<hub-modal-header
  [headerText]="'bikeshop.receipt_template.print_modal.title' | translate"
  [activeModal]="activeModal">
</hub-modal-header>

<div class="modal-content-container">
  <p class="spt-hint">{{ 'bikeshop.receipt_template.print_modal.hint' | translate }}</p>

  <div class="spt-list">
    <div
      *ngFor="let template of templates"
      class="spt-item"
      [class.spt-item--selected]="selectedTemplateId === template.id"
      (click)="select(template.id)">

      <input
        type="radio"
        class="spt-item__radio"
        [id]="'tpl-' + template.id"
        name="printTemplate"
        [value]="template.id"
        [(ngModel)]="selectedTemplateId" />

      <label [for]="'tpl-' + template.id" class="spt-item__body">
        <span class="spt-item__name">{{ template.name }}</span>
        <span class="spt-item__badge" *ngIf="template.isGlobalDefault">{{ 'bikeshop.receipt_template.print_modal.default_badge' | translate }}</span>
      </label>

      <i class="pi pi-check spt-item__check" *ngIf="selectedTemplateId === template.id"></i>
    </div>
  </div>
</div>

<div class="modal-footer-container">
  <div class="button-container">
    <hub-button
      [text]="'general.cancel' | translate"
      [style]="'outline'"
      [size]="'xl'"
      (buttonClick)="cancel()">
    </hub-button>
    <hub-button
      [text]="'bikeshop.receipt_template.print_modal.print_button' | translate"
      [style]="'secondary'"
      [size]="'xl'"
      [disabled]="!selectedTemplateId"
      (buttonClick)="confirm()">
    </hub-button>
  </div>
</div>
